/* ==========================================================================
   DANG — Cart drawer glue for the custom header
   --------------------------------------------------------------------------
   Dawn's cart drawer normally binds itself to "#cart-icon-bubble" and live-
   updates that element's count. DANG uses a custom header (dang-header) that
   has no #cart-icon-bubble, so this small script bridges the gap:
     1) Opens the drawer when the visible DANG cart links are clicked
        (falls back to navigating to /cart if the drawer isn't present).
     2) Keeps the DANG header cart count "(N)" in sync after every cart change,
        by listening to Dawn's cart pub/sub and re-reading /cart.js.
   ========================================================================== */
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* 1) Open the drawer from the custom header's cart links. */
  function wireCartLinks() {
    var selector =
      '.dang-header__utility-link[href*="/cart"],' +
      '.dang-header__mobile-cart,' +
      '.dang-header__drawer-utility-link[href*="/cart"]';
    document.querySelectorAll(selector).forEach(function (link) {
      link.addEventListener('click', function (e) {
        var drawer = getDrawer();
        if (!drawer) return; // no drawer -> let the link navigate to /cart
        e.preventDefault();
        drawer.open(link);
      });
    });
  }

  /* 2) Keep the header count in sync. Shows "(N)" / hides at 0, and injects the
        count span if the cart was empty on page load (the span isn't rendered
        server-side when item_count is 0). */
  function setCount(count) {
    var existing = document.querySelectorAll('.dang-header__cart-count');
    if (existing.length) {
      existing.forEach(function (el) {
        el.textContent = '(' + count + ')';
        el.style.display = count > 0 ? '' : 'none';
      });
    } else if (count > 0) {
      var cartLink = document.querySelector('.dang-header__utility-link[href*="/cart"]');
      if (cartLink) {
        var span = document.createElement('span');
        span.className = 'dang-header__cart-count';
        span.textContent = '(' + count + ')';
        cartLink.appendChild(span);
      }
    }
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  function init() {
    wireCartLinks();
    // Dawn exposes global subscribe()/PUB_SUB_EVENTS (pubsub.js, loaded in <head>).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCount(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
